import { InsuranceType } from '@subaio/api-types/service'
import { FormattedMessage } from '@subaio/components'
import { cases } from '@subaio/utils'

import { ButtonText } from 'components/Buttons'
import { Header } from 'components/Layout'

import { ButtonGroup } from './ButtonGroup'
import { Title } from './Title'

type Props = {
	type: InsuranceType

	onClose: () => void
}

export const Modal = ({ type, onClose }: Props) => (
	<>
		<Header>
			<Title>
				{cases(type, {
					[InsuranceType.Travel]: (
						<FormattedMessage id='insurance.policyScore.modal.title' defaultMessage='The policy score' />
					),
					[InsuranceType.Car]: (
						<FormattedMessage id='insurance.coverageScore.modal.title' defaultMessage='The coverage score' />
					),
				})}
			</Title>
			<p role='text'>
				{cases(type, {
					[InsuranceType.Travel]: (
						<FormattedMessage
							id='insurance.policyScore.modal.description'
							defaultMessage="Our partner RISK rates travel insurance policies on the quality of policy conditions. RISK's experts give the most important coverage components a score and a weighting percentage. This is how the policy score is established."
						/>
					),
					[InsuranceType.Car]: (
						<FormattedMessage
							id='insurance.coverageScore.modal.description'
							defaultMessage='This score is made up of various policy features including assistance, notice period and the impact of damage on your no-claims discount.'
						/>
					),
				})}
			</p>
		</Header>
		<ButtonGroup center>
			<ButtonText
				label={<FormattedMessage id='insurance.coverageScore.modal.buttonClose' defaultMessage='Close' />}
				onClick={onClose}
			/>
		</ButtonGroup>
	</>
)
